import { Injectable } from '@angular/core';
import { HttpInterceptorService } from '../http-interceptor/http-interceptor.service';
import { WallSetting } from '../../classes/wallsetting';
import { ToastService } from '../../shared/services/toast/toast.service';

@Injectable({
  providedIn: 'root'
})
export class WallSettingService {
  constructor(
    private _http: HttpInterceptorService,
    private toastService: ToastService
  ) {}

  getForStation(stationID): Promise<any> {
    return new Promise((resolve) => {
      this._http.get('WallSettings/ByStation/' + stationID).subscribe((wallsettings) => {
        resolve(wallsettings);
      });
    });
  }
  getSingle(wallsettingID): Promise<any> {
    return new Promise((resolve) => {
      this._http.get('WallSettings/' + wallsettingID).subscribe((wallsetting) => {
        resolve(wallsetting);
      });
    });
  }
  update(wallsetting: WallSetting): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.put('WallSettings', wallsetting).subscribe(
        (res) => {
          if (res.success && res.datas) {
            resolve(res.datas);
          } else {
            resolve(false);
          }
        },
        (err) => {
          reject(err);
        }
      );
    });
  }
  addNew(wallsetting: WallSetting): Promise<any> {
    return new Promise((resolve) => {
      this._http.post('WallSettings', wallsetting).subscribe(
        (res) => {
          if (res.success && res.datas) {
            resolve(res.datas);
          } else {
            this.toastService.error();
            resolve(false);
          }
        },
        (err) => {
          this.toastService.error(err);
          resolve(false);
        }
      );
    });
  }
  delete(wallsetting: WallSetting): Promise<any> {
    return new Promise((resolve) => {
      this._http.delete('WallSettings/' + wallsetting.PK_WallSettingsID).subscribe(
        (res) => {
          if (res.success) {
            resolve(res.success);
          } else {
            resolve(false);
          }
        },
        (err) => {
          resolve(false);
        }
      );
    });
  }
}
